import { render, staticRenderFns } from "./NominationApplyList.vue?vue&type=template&id=013829b6"
import script from "./NominationApplyList.vue?vue&type=script&lang=js"
export * from "./NominationApplyList.vue?vue&type=script&lang=js"
import style0 from "./NominationApplyList.vue?vue&type=style&index=0&id=013829b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports